import { Query } from '../../../_base/actionBus/Query';
import { Amenity } from '../../../models/amenities/Amenity';

export class GetAmenities extends Query<Amenity[]> {}
